import { useState } from 'react';
import { officetelTypes } from '../../../mocks/roadmapData';

const typeColors: Record<string, string> = {
  'A-1': 'bg-sky-50 text-sky-700 border-sky-200',
  'A-2': 'bg-indigo-50 text-indigo-700 border-indigo-200',
  'A-3': 'bg-violet-50 text-violet-700 border-violet-200',
  'A-4': 'bg-purple-50 text-purple-700 border-purple-200',
  'A-PH': 'bg-rose-50 text-rose-700 border-rose-200',
  'B-1': 'bg-sky-50 text-sky-700 border-sky-200',
  'B-2': 'bg-indigo-50 text-indigo-700 border-indigo-200',
  'B-3': 'bg-violet-50 text-violet-700 border-violet-200',
  'B-4': 'bg-purple-50 text-purple-700 border-purple-200',
  'B-PH': 'bg-rose-50 text-rose-700 border-rose-200',
};

const badgeColors: Record<string, string> = {
  'A-1': 'bg-sky-100 text-sky-800',
  'A-2': 'bg-indigo-100 text-indigo-800',
  'A-3': 'bg-violet-100 text-violet-800',
  'A-4': 'bg-purple-100 text-purple-800',
  'A-PH': 'bg-rose-100 text-rose-800',
  'B-1': 'bg-sky-100 text-sky-800',
  'B-2': 'bg-indigo-100 text-indigo-800',
  'B-3': 'bg-violet-100 text-violet-800',
  'B-4': 'bg-purple-100 text-purple-800',
  'B-PH': 'bg-rose-100 text-rose-800',
};

// 타입별 이미지 데이터
const typeImages: Record<string, { floorPlan: string; interior: string }> = {
  'A-1': {
    floorPlan: 'https://public.readdy.ai/ai/img_res/f609a5471204d0afe7770fc62a9f5a43.jpg',
    interior: 'https://readdy.ai/api/search-image?query=Sophisticated%20modern%20officetel%20interior%20design%2059%20square%20meters%20with%20premium%20wooden%20flooring%20floor-to-ceiling%20windows%20minimalist%20furniture%20neutral%20beige%20and%20white%20color%20palette%20natural%20daylight%20streaming%20through%20large%20windows%20elegant%20contemporary%20style%20high-end%20residential%20atmosphere&width=800&height=600&seq=a1interior&orientation=landscape'
  },
  'A-2': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Premium%20officetel%20architectural%20floor%20plan%2084%20square%20meters%20two%20bedroom%20layout%20with%20master%20bedroom%20guest%20room%20two%20bathrooms%20modern%20open%20kitchen%20and%20spacious%20living%20area%20detailed%20blueprint%20style%20with%20dimension%20lines%20professional%20architectural%20drawing%20clean%20background&width=800&height=600&seq=a2floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Luxurious%20contemporary%20officetel%20living%20room%20interior%2084%20square%20meters%20with%20designer%20furniture%20marble%20flooring%20ambient%20lighting%20modern%20chandelier%20large%20panoramic%20windows%20city%20view%20elegant%20neutral%20tones%20with%20gold%20accents%20high-end%20residential%20design&width=800&height=600&seq=a2interior&orientation=landscape'
  },
  'A-3': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Spacious%20officetel%20floor%20plan%20design%20101%20square%20meters%20featuring%20three%20bedrooms%20two%20bathrooms%20walk-in%20closet%20modern%20kitchen%20with%20island%20living%20dining%20area%20architectural%20blueprint%20with%20measurements%20and%20annotations%20professional%20presentation%20style&width=800&height=600&seq=a3floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=High-end%20modern%20officetel%20master%20bedroom%20interior%20101%20square%20meters%20with%20king%20size%20bed%20premium%20bedding%20floor-to-ceiling%20windows%20city%20skyline%20view%20elegant%20lighting%20fixtures%20minimalist%20contemporary%20design%20warm%20neutral%20color%20palette%20luxury%20residential%20atmosphere&width=800&height=600&seq=a3interior&orientation=landscape'
  },
  'A-4': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Large%20premium%20officetel%20architectural%20plan%20118%20square%20meters%20with%20three%20bedrooms%20master%20suite%20two%20full%20bathrooms%20gourmet%20kitchen%20spacious%20living%20area%20detailed%20floor%20plan%20blueprint%20style%20with%20room%20dimensions%20professional%20real%20estate%20layout%20drawing&width=800&height=600&seq=a4floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20officetel%20open%20concept%20living%20space%20118%20square%20meters%20with%20designer%20kitchen%20island%20marble%20countertops%20contemporary%20furniture%20sophisticated%20lighting%20large%20windows%20natural%20light%20modern%20minimalist%20interior%20design%20high-end%20finishes&width=800&height=600&seq=a4interior&orientation=landscape'
  },
  'A-PH': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Exclusive%20penthouse%20officetel%20floor%20plan%20135%20square%20meters%20featuring%20master%20suite%20guest%20bedrooms%20private%20terrace%20outdoor%20space%20luxury%20bathrooms%20gourmet%20kitchen%20architectural%20blueprint%20with%20terrace%20layout%20professional%20high-end%20residential%20design%20drawing&width=800&height=600&seq=aphfloor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Ultra-luxury%20penthouse%20officetel%20interior%20135%20square%20meters%20with%20floor-to-ceiling%20glass%20walls%20panoramic%20city%20views%20premium%20Italian%20furniture%20marble%20flooring%20designer%20lighting%20fixtures%20private%20terrace%20access%20contemporary%20sophisticated%20design%20exclusive%20residential%20atmosphere&width=800&height=600&seq=aphinterior&orientation=landscape'
  },
  'B-1': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Compact%20modern%20officetel%20floor%20plan%2059%20square%20meters%20one%20bedroom%20one%20bathroom%20efficient%20layout%20open%20kitchen%20living%20area%20architectural%20blueprint%20style%20with%20measurements%20clean%20professional%20presentation%20quality%20real%20estate%20drawing&width=800&height=600&seq=b1floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Contemporary%20officetel%20studio%20interior%2059%20square%20meters%20with%20smart%20space-saving%20furniture%20wooden%20accents%20large%20windows%20natural%20lighting%20minimalist%20Scandinavian%20style%20neutral%20color%20palette%20modern%20residential%20design%20cozy%20atmosphere&width=800&height=600&seq=b1interior&orientation=landscape'
  },
  'B-2': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Modern%20two%20bedroom%20officetel%20floor%20plan%2084%20square%20meters%20with%20master%20bedroom%20second%20bedroom%20two%20bathrooms%20contemporary%20kitchen%20living%20space%20architectural%20blueprint%20detailed%20measurements%20professional%20layout%20drawing&width=800&height=600&seq=b2floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20officetel%20dining%20area%20interior%2084%20square%20meters%20with%20elegant%20dining%20table%20designer%20chairs%20pendant%20lighting%20open%20kitchen%20view%20large%20windows%20natural%20daylight%20contemporary%20furniture%20high-end%20residential%20finishes&width=800&height=600&seq=b2interior&orientation=landscape'
  },
  'B-3': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Three%20bedroom%20officetel%20architectural%20plan%20101%20square%20meters%20featuring%20master%20suite%20two%20additional%20bedrooms%20two%20bathrooms%20modern%20kitchen%20dining%20living%20area%20floor%20plan%20blueprint%20with%20room%20labels%20and%20dimensions&width=800&height=600&seq=b3floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Premium%20officetel%20kitchen%20interior%20101%20square%20meters%20with%20modern%20cabinetry%20quartz%20countertops%20stainless%20steel%20appliances%20pendant%20lighting%20open%20layout%20connected%20to%20living%20space%20contemporary%20design%20natural%20light%20luxury%20residential%20quality&width=800&height=600&seq=b3interior&orientation=landscape'
  },
  'B-4': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Spacious%20three%20bedroom%20officetel%20floor%20plan%20118%20square%20meters%20with%20master%20bedroom%20suite%20walk-in%20closet%20two%20guest%20bedrooms%20two%20bathrooms%20modern%20kitchen%20living%20dining%20architectural%20blueprint%20professional%20presentation&width=800&height=600&seq=b4floor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Luxurious%20officetel%20bathroom%20interior%20118%20square%20meters%20with%20double%20vanity%20marble%20tiles%20rainfall%20shower%20glass%20enclosure%20modern%20fixtures%20ambient%20lighting%20contemporary%20spa-like%20design%20high-end%20residential%20finishes&width=800&height=600&seq=b4interior&orientation=landscape'
  },
  'B-PH': {
    floorPlan: 'https://readdy.ai/api/search-image?query=Penthouse%20officetel%20architectural%20floor%20plan%20135%20square%20meters%20with%20master%20suite%20multiple%20bedrooms%20private%20terrace%20rooftop%20access%20luxury%20amenities%20detailed%20blueprint%20professional%20high-end%20residential%20layout%20drawing&width=800&height=600&seq=bphfloor&orientation=landscape',
    interior: 'https://readdy.ai/api/search-image?query=Exclusive%20penthouse%20officetel%20terrace%20interior%20135%20square%20meters%20with%20outdoor%20lounge%20furniture%20panoramic%20city%20skyline%20views%20premium%20decking%20modern%20outdoor%20lighting%20luxury%20outdoor%20living%20space%20sophisticated%20contemporary%20design&width=800&height=600&seq=bphinterior&orientation=landscape'
  }
};

export default function OfficetelTypeTable() {
  const [activeBuilding, setActiveBuilding] = useState<'A' | 'B'>('A');
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [imageView, setImageView] = useState<'floorPlan' | 'interior'>('floorPlan');

  const building = activeBuilding === 'A' ? officetelTypes.buildingA : officetelTypes.buildingB;

  const totalUnitsAll =
    officetelTypes.buildingA.totalUnits + officetelTypes.buildingB.totalUnits;

  const selectedTypeData = building.types.find(t => t.type === selectedType);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest text-teal-600 uppercase mb-3">
            Unit Mix & Pricing
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            오피스텔 세대별 타입 상세표
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            A·B동 총 311세대의 전용면적, 공급면적, 층별 배치 및 분양가 상세 정보를 확인하세요.
          </p>
        </div>

        {/* Total Summary */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm text-center">
            <div className="text-xs text-gray-400 font-medium mb-1">총 세대수</div>
            <div className="text-2xl font-bold text-gray-900">{totalUnitsAll}<span className="text-sm text-gray-500 ml-1">세대</span></div>
          </div>
          <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm text-center">
            <div className="text-xs text-gray-400 font-medium mb-1">오피스텔 총 분양수입</div>
            <div className="text-2xl font-bold text-gray-900">6,917<span className="text-sm text-gray-500 ml-1">억원</span></div>
          </div>
          <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm text-center">
            <div className="text-xs text-gray-400 font-medium mb-1">평균 분양가</div>
            <div className="text-2xl font-bold text-gray-900">1.35<span className="text-sm text-gray-500 ml-1">억/평</span></div>
          </div>
          <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm text-center">
            <div className="text-xs text-gray-400 font-medium mb-1">규모</div>
            <div className="text-2xl font-bold text-gray-900">지하10<span className="text-sm text-gray-500 ml-1">~지상30층</span></div>
          </div>
        </div>

        {/* Building Tab */}
        <div className="flex gap-3 mb-8">
          {(['A', 'B'] as const).map((b) => {
            const bd = b === 'A' ? officetelTypes.buildingA : officetelTypes.buildingB;
            return (
              <button
                key={b}
                onClick={() => {
                  setActiveBuilding(b);
                  setSelectedType(null);
                }}
                className={`px-6 py-3 rounded-xl font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                  activeBuilding === b
                    ? 'bg-gray-900 text-white shadow-md'
                    : 'bg-white text-gray-600 border border-gray-200 hover:border-gray-400'
                }`}
              >
                {bd.name} ({bd.totalUnits}세대)
              </button>
            );
          })}
        </div>

        {/* Building Info Bar */}
        <div className="flex flex-wrap items-center gap-6 bg-white rounded-xl px-6 py-4 border border-gray-100 shadow-sm mb-6">
          <div>
            <span className="text-xs text-gray-400">총 세대</span>
            <span className="ml-2 font-bold text-gray-900">{building.totalUnits}세대</span>
          </div>
          <div className="w-px h-5 bg-gray-200"></div>
          <div>
            <span className="text-xs text-gray-400">총 분양수입</span>
            <span className="ml-2 font-bold text-teal-700">{building.totalRevenue}</span>
          </div>
          <div className="w-px h-5 bg-gray-200"></div>
          <div>
            <span className="text-xs text-gray-400">평균 분양가</span>
            <span className="ml-2 font-bold text-gray-900">{building.avgPricePerPyeong}/평</span>
          </div>
          <div className="w-px h-5 bg-gray-200"></div>
          <div>
            <span className="text-xs text-gray-400">타입 수</span>
            <span className="ml-2 font-bold text-gray-900">{building.types.length}종</span>
          </div>
        </div>

        {/* Type Cards (visual summary) - Now clickable */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8">
          {building.types.map((t) => (
            <button
              key={t.type}
              onClick={() => setSelectedType(t.type)}
              className={`rounded-xl border p-4 transition-all cursor-pointer ${
                selectedType === t.type 
                  ? 'ring-2 ring-teal-500 shadow-lg scale-105' 
                  : 'hover:shadow-md hover:scale-102'
              } ${typeColors[t.type] || 'bg-gray-50 text-gray-700 border-gray-200'}`}
            >
              <div className="flex items-center justify-between mb-2">
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${badgeColors[t.type] || 'bg-gray-100 text-gray-700'}`}>
                  {t.type}
                </span>
                <span className="text-xs font-medium opacity-70">{t.units}세대</span>
              </div>
              <div className="text-lg font-bold mb-0.5">{t.exclusiveArea}</div>
              <div className="text-xs opacity-70 mb-2">{t.pyeong} · {t.floorRange}</div>
              <div className="text-sm font-semibold">{t.unitPrice}</div>
              <div className="text-xs opacity-60 mt-0.5">{t.features}</div>
            </button>
          ))}
        </div>

        {/* Image Gallery Section */}
        {selectedType && selectedTypeData && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-lg overflow-hidden mb-8 animate-fadeIn">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-image-line text-teal-600 text-base"></i>
                </div>
                <span className="font-semibold text-gray-800 text-sm">
                  {selectedType} 타입 평면도 & 인테리어 컨셉
                </span>
                <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${badgeColors[selectedType]}`}>
                  {selectedTypeData.exclusiveArea} · {selectedTypeData.pyeong}
                </span>
              </div>
              <button
                onClick={() => setSelectedType(null)}
                className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {/* Image View Toggle */}
            <div className="px-6 py-4 bg-gray-50 flex gap-2">
              <button
                onClick={() => setImageView('floorPlan')}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  imageView === 'floorPlan'
                    ? 'bg-teal-600 text-white shadow-md'
                    : 'bg-white text-gray-600 border border-gray-200 hover:border-teal-300'
                }`}
              >
                <i className="ri-layout-line mr-2"></i>
                평면도
              </button>
              <button
                onClick={() => setImageView('interior')}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  imageView === 'interior'
                    ? 'bg-teal-600 text-white shadow-md'
                    : 'bg-white text-gray-600 border border-gray-200 hover:border-teal-300'
                }`}
              >
                <i className="ri-home-smile-line mr-2"></i>
                인테리어 컨셉
              </button>
            </div>

            {/* Image Display */}
            <div className="relative bg-gray-100">
              <div className="w-full h-[500px]">
                <img
                  src={imageView === 'floorPlan' ? typeImages[selectedType].floorPlan : typeImages[selectedType].interior}
                  alt={`${selectedType} ${imageView === 'floorPlan' ? '평면도' : '인테리어'}`}
                  className="w-full h-full object-contain"
                />
              </div>
              
              {/* Image Overlay Badge */}
              <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-3 shadow-lg">
                <div className="flex items-center gap-3">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${badgeColors[selectedType]}`}>
                    {selectedType}
                  </span>
                  <div className="w-px h-4 bg-gray-300"></div>
                  <div className="text-xs">
                    <div className="text-gray-500 mb-0.5">전용면적</div>
                    <div className="font-bold text-gray-900">{selectedTypeData.exclusiveArea}</div>
                  </div>
                  <div className="w-px h-4 bg-gray-300"></div>
                  <div className="text-xs">
                    <div className="text-gray-500 mb-0.5">층</div>
                    <div className="font-bold text-gray-900">{selectedTypeData.floorRange}</div>
                  </div>
                  <div className="w-px h-4 bg-gray-300"></div>
                  <div className="text-xs">
                    <div className="text-gray-500 mb-0.5">분양가</div>
                    <div className="font-bold text-teal-700">{selectedTypeData.unitPrice}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Type Details */}
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div>
                  <div className="text-xs text-gray-500 mb-1">특징</div>
                  <div className="text-sm font-medium text-gray-900">{selectedTypeData.features}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">공급면적</div>
                  <div className="text-sm font-medium text-gray-900">{selectedTypeData.supplyArea}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">세대수</div>
                  <div className="text-sm font-medium text-gray-900">{selectedTypeData.units}세대</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">타입 총 수입</div>
                  <div className="text-sm font-bold text-teal-700">{selectedTypeData.totalRevenue}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Detailed Table */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-table-line text-teal-600 text-base"></i>
            </div>
            <span className="font-semibold text-gray-800 text-sm">{building.name} 세대별 타입 상세표</span>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50 text-gray-500 text-xs font-semibold uppercase tracking-wide">
                  <th className="px-5 py-3 text-left">타입</th>
                  <th className="px-5 py-3 text-left">특징</th>
                  <th className="px-5 py-3 text-right">전용면적</th>
                  <th className="px-5 py-3 text-right">공급면적</th>
                  <th className="px-5 py-3 text-right">평형</th>
                  <th className="px-5 py-3 text-right">세대수</th>
                  <th className="px-5 py-3 text-center">층</th>
                  <th className="px-5 py-3 text-right">분양가/평</th>
                  <th className="px-5 py-3 text-right">세대당 분양가</th>
                  <th className="px-5 py-3 text-right">타입 총 수입</th>
                </tr>
              </thead>
              <tbody>
                {building.types.map((t, idx) => (
                  <tr
                    key={t.type}
                    onClick={() => setSelectedType(t.type)}
                    className={`border-t border-gray-50 hover:bg-teal-50 transition-colors cursor-pointer ${
                      idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/40'
                    } ${selectedType === t.type ? 'bg-teal-50' : ''}`}
                  >
                    <td className="px-5 py-4">
                      <span className={`inline-block text-xs font-bold px-2.5 py-1 rounded-full border ${typeColors[t.type] || ''}`}>
                        {t.type}
                      </span>
                    </td>
                    <td className="px-5 py-4 text-gray-600 text-xs">{t.features}</td>
                    <td className="px-5 py-4 text-right font-medium text-gray-800">{t.exclusiveArea}</td>
                    <td className="px-5 py-4 text-right text-gray-500">{t.supplyArea}</td>
                    <td className="px-5 py-4 text-right text-gray-600">{t.pyeong}</td>
                    <td className="px-5 py-4 text-right font-semibold text-gray-900">{t.units}세대</td>
                    <td className="px-5 py-4 text-center text-gray-500 text-xs">{t.floorRange}</td>
                    <td className="px-5 py-4 text-right text-teal-700 font-medium">{t.pricePerPyeong}</td>
                    <td className="px-5 py-4 text-right font-bold text-gray-900">{t.unitPrice}</td>
                    <td className="px-5 py-4 text-right font-bold text-teal-700">{t.totalRevenue}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-900 text-white">
                  <td className="px-5 py-4 font-bold text-sm" colSpan={5}>합계</td>
                  <td className="px-5 py-4 text-right font-bold">{building.totalUnits}세대</td>
                  <td className="px-5 py-4"></td>
                  <td className="px-5 py-4 text-right text-gray-300 text-xs">평균 {building.avgPricePerPyeong}</td>
                  <td className="px-5 py-4"></td>
                  <td className="px-5 py-4 text-right font-bold text-teal-300">{building.totalRevenue}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Note */}
        <div className="mt-5 flex items-start gap-2 text-xs text-gray-400">
          <div className="w-4 h-4 flex items-center justify-center mt-0.5">
            <i className="ri-information-line text-gray-400"></i>
          </div>
          <p>
            분양가는 평당 1.28~1.50억원 기준이며, 층수·향·조망에 따라 ±5% 내외 조정될 수 있습니다.
            전용면적은 집합건물법 기준이며, 공급면적은 주거전용 + 주거공용 합산 기준입니다.
            펜트하우스(PH) 타입은 테라스 면적 별도 산정됩니다.
            타입 카드 또는 테이블 행을 클릭하면 평면도 및 인테리어 컨셉 이미지를 확인할 수 있습니다.
          </p>
        </div>
      </div>
    </section>
  );
}